<template>
  <div>
    <ysz-census />
  </div>
</template>

<script>
// 获取接口地址
import YszCensus from '../components/tjbb/yszCensus.vue'

export default {
  name: 'Yszsyqktj',
  components: {
    // sideMenu,
    // Header,
    YszCensus
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
